"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiesole": {
    "ed338e4d": [{
      "hkey": "6cf84d76",
      "slug": "fiesole",
      "name": "Fiesole",
      "primary": true,
      "skipSearch": false
    }],
    "anchetta": [{
      "hkey": "6cf84d76",
      "slug": "fiesole",
      "name": "Fiesole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "edfd5970": [{
      "hkey": "6cf84d76",
      "slug": "fiesole",
      "name": "Fiesole",
      "primary": true,
      "skipSearch": false
    }],
    "salviatino": [{
      "hkey": "6cf84d76",
      "slug": "fiesole",
      "name": "Fiesole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04f2986c": [{
      "hkey": "6cf84d76",
      "slug": "fiesole",
      "name": "Fiesole",
      "primary": true,
      "skipSearch": false
    }],
    "valico-vetta-le-croci": [{
      "hkey": "6cf84d76",
      "slug": "fiesole",
      "name": "Fiesole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;